import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import QuestionFileImgSet from './QuestionFileImgSet.vue';
import VueAliplayer from '@/components/live/VueAliplayer.vue'; //音频录制组件

import Record from '@/components/live/Record.vue';
export default {
  name: 'QuestionFileSet',
  props: {
    showType: {
      type: Number,
      default: 0
    },
    initQuestionInfo: {},
    value: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      //要设置背景图片的音频或视频
      fileOne: {},
      //弹出层是否打开
      addDialogFlag: false,
      //弹出层名称
      addDialogTitle: "背景图片设置",
      eqContentIfFileList: [{
        DIC_ID: 1,
        DIC_NAME: '无附件'
      }, {
        DIC_ID: 2,
        DIC_NAME: '上传附件'
      }, {
        DIC_ID: 3,
        DIC_NAME: '录制附件'
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  components: {
    QuestionFileImgSet: QuestionFileImgSet,
    "ali-player": VueAliplayer,
    Record: Record
  },
  methods: {
    /**
     * 打开音频的背景图片设置
     */
    openFileImgSet: function openFileImgSet(fileOne) {
      this.fileOne = fileOne; //弹出层是否打开

      this.addDialogFlag = true; //弹出层名称

      this.addDialogTitle = "背景图片设置";
    },

    /**
     * 文件上传成功时的处理函数
     */
    successFile: function successFile(response, file, fileList, type) {
      var that = this;
      var arr = response.split(":");
      var downAddress = arr[0];
      var fileId = arr[1];
      file.fileId = fileId;
      file.downAddress = downAddress;
      var toHtId = "";
      fileList.forEach(function (element) {
        if (element.status == "success") {
          if (toHtId != "") {
            toHtId += ",";
          }

          toHtId += element.fileId;
        }

        var name = element.name;
        element.fileType = that.getFileTypeByName(name);
      });

      if (type == 0) {
        this.value.eqContentFileId = toHtId;
        this.value.eqContentFile = fileList;
      } else if (type == 1) {
        this.value.prevSet.eqContentVolume = fileList;
      }
    },

    /**
     * 文件删除时的处理函数
     */
    removeFile: function removeFile(file, fileList, fieldSetOne, type) {
      var that = this;
      var toHtId = "";
      fileList.forEach(function (element) {
        if (element.status == "success") {
          if (toHtId != "") {
            toHtId += ",";
          }

          toHtId += element.fileId;
        }

        var name = element.name;
        element.fileType = that.getFileTypeByName(name);
      });

      if (type == 0) {
        this.value.eqContentFileId = toHtId;
        this.value.eqContentFile = fileList;
      } else if (type == 1) {
        this.value.prevSet.eqContentVolume = fileList;
      }
    },

    /**
     * 文件上传个数超出时进行提醒
     */
    exceedFile: function exceedFile(files, fileList) {
      this.$message({
        message: '最大文件上传个数为:' + 5 + ",不可超出!",
        type: 'warning'
      });
    },

    /**
     * 录制音频结束时 进行题目附件的绑定
     */
    setEqContentFile: function setEqContentFile(audioSrc) {
      this.value.eqContentFile = audioSrc;
    },

    /**
     * 根据文件名称获取文件类型
     */
    getFileTypeByName: function getFileTypeByName(name) {
      var fileType = 'image';

      if (name.indexOf(".jpg") > 0 || name.indexOf(".png") > 0) {
        fileType = "image";
      } else if (name.indexOf(".mp4") > 0 || name.indexOf(".m3u8") > 0 || name.indexOf(".flv") > 0) {
        fileType = "video";
      } else if (name.indexOf(".mp3") > 0) {
        fileType = "audio";
      }

      return fileType;
    },

    /**
     * 附件类型切换时 进行附件的
     */
    eqContentIfFileChange: function eqContentIfFileChange() {
      if (this.value.eqContentIfFile == 1) {
        this.value.eqContentFile = [];
      }
    },

    /**
     * 删除题目录音
     */
    deleteEqContentVolume: function deleteEqContentVolume(index) {
      var eqContentVolume = this.value.prevSet.eqContentVolume;
      eqContentVolume.splice(index, 1);
      this.value.prevSet.eqContentVolume = eqContentVolume;
    },

    /**
     * 删除题目附件
     */
    deleteEqContentFile: function deleteEqContentFile(index) {
      var eqContentFile = this.value.eqContentFile;
      eqContentFile.splice(index, 1);
      this.value.eqContentFile = eqContentFile;
    }
  }
};